export default "/images/0f83701705d816c205e258520c31c3e9.avif";